import {useProductRating} from "./useProductRating";

export const useRatingsAccordionHeader = () => {
    const {count, grade} = useProductRating();

    return {
        title: 'Reviews',
        hasSubTitle: count > 0,
        count,
        grade
    };
}